/** Report detail page, holding tabs for analysis, kinematics, and overview */
import { IonIcon, IonLabel, IonLoading, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from '@ionic/react';

import * as React from 'react';

import { Redirect, Route } from 'react-router-dom';

import { useEffect, useState } from 'react';

// Custom Icons
import ORYX_VariabilityIcon from '../../../../assets/icons/ORYX_VariabilityIcon.svg';
import ORYX_ScissorsIcon from '../../../../assets/icons/ORYX_ScissorsIcon.svg';
import ORYX_AttractorsIcon from '../../../../assets/icons/ORYX_AttractorsIcon.svg';
import ORYX_ReportStatusIcon from '../../../../assets/icons/ORYX_ReportStatusIcon.svg';
import ORYX_KinematicsIcon from '../../../../assets/icons/ORYX_KinematicsIcon.svg';
import ORYX_InformationIcon from '../../../../assets/icons/ORYX_InformationIcon.svg';

//   Custom css
import './index.css';

import {
  SingleLegSquatAnalysisReportTab,
  SingleLegSquatsKinematicsReportTab,
  SingleLegSquatsVariabilityReportTab,
} from '../../SingleLegSquatsReportV2';

interface ReportTab {
  url: string;
  title: string;
  status: string;
  icon: string;
}

const squatTabs: ReportTab[] = [
  {
    title: 'Analysis',
    url: `analysis`,
    status: 'active',
    icon: ORYX_ReportStatusIcon,
  },
  {
    title: 'Variability',
    url: 'variability',
    status: 'active',
    icon: ORYX_VariabilityIcon,
  },
  {
    title: 'Kinematics',
    url: 'kinematics',
    status: 'active',
    icon: ORYX_KinematicsIcon,
  },

  // {
  //   title: 'Overview',
  //   url: 'overview',
  //   status: 'active',
  //   icon: ORYX_InformationIcon,
  // },
];

interface RunTabsProps {
  id: string;
  data: any;
}

export const SingleLegSquatTabBar = ({ id, data }: RunTabsProps) => {
  const [activeRunTab, setActiveRunTab] = useState('Analysis');
  //   console.log('data', data);
  const [loadingData, setLoadingData] = useState(false);
  console.log(data);

  // Set custom actions on the tabs
  const handleTabWillChange = (e: any) => {
    setActiveRunTab(e.detail.tab);
  };

  return (
    <IonTabs onIonTabsWillChange={handleTabWillChange}>
      {loadingData && (
        <IonLoading cssClass='my-custom-class' isOpen={loadingData} message={'Drawing graphs, one moment please...'} />
      )}
      <IonRouterOutlet id='main'>
        <Route
          path='/reportsV2/:id/analysis'
          render={(props) => {
            return <SingleLegSquatAnalysisReportTab {...props} report={data} />;
          }}
          exact={true}
        />
        <Route
          path='/reportsV2/:id/variability'
          render={(props) => {
            return <SingleLegSquatsVariabilityReportTab {...props} report={data} />;
          }}
          exact={true}
        />
        <Route
          path='/reportsV2/:id/kinematics'
          render={(props) => {
            return <SingleLegSquatsKinematicsReportTab {...props} report={data} />;
          }}
          exact={true}
        />

        <Route path={`/reportsV2/${id}`} render={() => <Redirect to={`/reportsV2/${id}/analysis`} />} exact={true} />
      </IonRouterOutlet>

      <IonTabBar slot='bottom' mode='ios'>
        {squatTabs.map((tab, _) => {
          let tabClassNames = '';
          if (tab.status === 'disabled') {
            tabClassNames = 'disabled';
          } else if (location.pathname === tab.url) {
            tabClassNames = 'ion-tab-button_selected';
          }
          return (
            <IonTabButton
              mode='ios'
              tab={tab.title}
              href={`/reportsV2/${id}/${tab.url}`}
              className={activeRunTab === tab.title ? 'ion-tab-button_selected' : ''}
              key={tab.title}>
              <IonIcon icon={tab.icon} />
              <IonLabel>{tab.title}</IonLabel>
            </IonTabButton>
          );
        })}
      </IonTabBar>
    </IonTabs>
  );
};
